import React, { Component } from 'react';

class Home extends Component {
  render() {
    const { authState, authData } = this.props;
    return (
      <div id="home-module">
        <h1>Home</h1>
        <h2>{authState}</h2>
        {authData == null ? (
          <div>Logged out</div>
        ) : (
          <table>
            <tbody>
              <tr><th>email</th><td>{authData.email}</td></tr>
              <tr><th>username</th><td>{authData.username}</td></tr>
              <tr><th>id</th><td>{authData.id}</td></tr>
              <tr><th>s3 path</th><td>s3://clouddirect/clients/{authData.id}/</td></tr>
              <tr><th>idToken</th><td className="token"><textarea cols="80" rows="5" value={authData.idToken} readOnly /></td></tr>
              <tr><th>refreshToken</th><td className="token"><textarea cols="80" rows="5" value={authData.refreshToken} readOnly /></td></tr>
              <tr><th>accessToken</th><td className="token"><textarea cols="80" rows="5" value={authData.accessToken} readOnly /></td></tr>
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default Home;


// WEBPACK FOOTER //
// ./src/modules/Home.jsx